module.exports = __webpack_public_path__ + "static/media/japan-post.f107f6ed.svg";